import {createApp} from 'vue'
import options from './StafetEditPageHero.options'

const el = '.kb-component--stafet-edit-page-hero'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((StafetEditPageHeroDOM)=>{
            const component = createApp(options).use(Store)
            component.mount(StafetEditPageHeroDOM)
        })
    }
}

